/**
 * Employee Web — `/me/reviews/results/$cycleId`: the employee's results for
 * one review cycle (their manager's rating and summary, then the answers side
 * by side with their own self-review).
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { MyResultsView } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/reviews/results/$cycleId")({
  staticData: { breadcrumb: { labelKey: "appraisal:reviews.results.crumb" } },
  component: MyResultsRoute,
});

function MyResultsRoute(): JSX.Element {
  const { cycleId } = Route.useParams();
  return <MyResultsView cycleId={cycleId} />;
}
